<div class="summary-section">
    <div class="page-content">
        <h2 class="heading1 sorder">Sales Order Summary</h2>
        <div class="card">
            <div class="card-body s-card1">
                <h3 class="heading3">Anil Kumar</h3>
                <div class="row">
                    <div class="col">
                        <label for="" class="label1">Document Series</label>
                        <label for="" class="label2">1002432212</label>
                    </div>
                    <div class="col">
                        <label for="" class="label1">Document Number</label>
                        <label for="" class="label2">0023333331</label>
                    </div>
                    <div class="col">
                        <label for="" class="label1">Document Date</label>
                        <label for="" class="label2">10/03/2023</label>
                    </div>
                    <div class="col">
                        <label for="" class="label1">Posting Date</label>
                        <label for="" class="label2">10/03/2023</label>
                    </div>
                    <div class="col">
                        <label for="" class="label1">Delivery Date</label>
                        <label for="" class="label2">10/03/2023</label>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <label for="" class="label1">Branch Name</label>
                        <label for="" class="label2">Greater Noida</label>
                    </div>
                    <div class="col">
                        <label for="" class="label1">Contact Person</label>
                        <label for="" class="label2">Abhishek Singh</label>
                    </div>
                    <div class="col">
                        <label for="" class="label1">Sales Person</label>
                        <label for="" class="label2">Abhishek Singh</label>
                    </div>
                    <div class="col">
                        <label for="" class="label1">Place of supply</label>
                        <label for="" class="label2">Gautambudha Nagar</label>
                    </div>
                    <div class="col"></div>
                </div>
            </div>
        </div>
        <div class="card mt-4">
            <div class="card-body s-card2">
                <h3 class="heading3">Total Items (5)</h3>
                <div class="tabledesign">
                    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

                        <!-- Item Column -->
                        <ng-container matColumnDef="item">
                            <th mat-header-cell *matHeaderCellDef> Item </th>
                            <td mat-cell *matCellDef="let element" class="fw-bold"> {{element.item}} </td>
                        </ng-container>

                        <!-- Qty Column -->
                        <ng-container matColumnDef="qty">
                            <th mat-header-cell *matHeaderCellDef> Qty </th>
                            <td mat-cell *matCellDef="let element"> {{element.qty}} </td>
                        </ng-container>

                        <!-- Unit Price Column -->
                        <ng-container matColumnDef="unit_price">
                            <th mat-header-cell *matHeaderCellDef> Unit Price </th>
                            <td mat-cell *matCellDef="let element"> {{element.unit_price}} </td>
                        </ng-container>

                        <!-- Discount % Column -->
                        <ng-container matColumnDef="discount">
                            <th mat-header-cell *matHeaderCellDef> Discount % </th>
                            <td mat-cell *matCellDef="let element"> {{element.discount}} </td>
                        </ng-container>

                        <!-- Discount Amount Column -->
                        <ng-container matColumnDef="discount_amount">
                            <th mat-header-cell *matHeaderCellDef> Discount Amount </th>
                            <td mat-cell *matCellDef="let element"> {{element.discount_amount}} </td>
                        </ng-container>

                        <!-- Tax Code Column -->
                        <ng-container matColumnDef="tax_code">
                            <th mat-header-cell *matHeaderCellDef> Tax Code </th>
                            <td mat-cell *matCellDef="let element"> {{element.tax_code}} </td>
                        </ng-container>

                        <!-- Tax Amount Column -->
                        <ng-container matColumnDef="tax_amount">
                            <th mat-header-cell *matHeaderCellDef> tax_amount </th>
                            <td mat-cell *matCellDef="let element"> {{element.tax_amount}} </td>
                        </ng-container>

                        <!-- Amount Column -->
                        <ng-container matColumnDef="amount">
                            <th mat-header-cell *matHeaderCellDef> Amount </th>
                            <td mat-cell *matCellDef="let element"> {{element.amount}} </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>


                </div>
                <div class="row mt-5">
                    <div class="col-md-6">
                        <div class="fw-bold mb-2">Notes/Remarks</div>
                        <div class="">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla semper faucibus
                            eros vitae faucibus. Mauris hendrerit justo non laoreet placerat.</div>
                    </div>
                    <div class="col-md-6">
                        <div class="entry-forms accounting-section">
                            <div class="acclist">
                                <div class="p-0 pb-2 acclist-item">
                                    <div class="me-auto">Sub-Total</div>
                                    <div>&#8377; 22,500.00</div>
                                </div>
                                <div class="divider"></div>
                                <div class="p-0 my-2 acclist-item">
                                    <div class="me-auto">Discount</div>
                                    <div class="">&#8377; 2,000.00</div>
                                </div>
                                <div class="divider"></div>
                                <div class="p-0 my-2 acclist-item">
                                    <div class="me-auto">Freight</div>
                                    <div class="">&#8377; 18,000.00</div>
                                </div>
                                <div class="divider"></div>
                                <div class="p-0 my-2 acclist-item">
                                    <div class="me-auto">Tax</div>
                                    <div>&#8377; 18,000.00</div>
                                </div>
                                <div class="divider"></div>
                            </div>
                            <div class="py-4 d-flex">
                                <div class="me-auto fs-6 fw-bold pt-2">Total</div>
                                <div class="fs-6 fw-bold">&#8377;57,00,000.00 </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="mt-2 footer">
        <div class="row">
            <div class="col-md-6"></div>
            <div class="col-md-6 text-end">
                <button mat-raised-button color="primary" class="me-1">Go Back to Edit</button>
                <button #buttonSave mat-raised-button color="primary" class="me-1">Submit</button>
            </div>
        </div>
    </div>
</div>